<template>
    <div class="content-wrapper">
      <div class="container-lg">
        <div class="row mb-12">
          <div class="col">
            <div class="page-title-nav row">
              <div class="col-2 col-lg-3">
                <a href="#" class="btn btn-outline-secondary btn-custom btn-back"><i
                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                    class="d-none d-lg-block ms-2">ย้อนกลับ</span></a>
              </div>
              <div class="col-8 col-lg-6">
                <h1 class="page-title">รีวิว</h1>
              </div>
              <div class="col-12 col-lg-3">
                <a @click="modalShow = !modalShow" href="#" class="btn btn-primary btn-custom"  data-bs-toggle="modal" data-bs-target="#reviewModal"><i
                    class="fa-icon fa-regular fa-pen"></i><span>เขียนรีวิว</span></a>
              </div>
            </div>
            <div class="section-review d-grid gap-4 mb-4">
                <b-modal v-model="modalShow">Hello From Modal!</b-modal>
                <app-review-card  v-for="index in 10" :key="index" />
              <!-- <div class="review-card">
                <div class="review-header">
                  <div class="user-info">
                    <div class="user-img">
                      <img src="assets/images/default-profile-img.png" class="img-fluid" />
                    </div>
                    <h5 class="user-number mb-0">0***9</h5>
                  </div>
                  <div class="timestamp">13/8/24</div>
                </div>
                <div class="review-stars">
                  <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i
                    class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i>
                </div>
                <div class="review-body">
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
                <div class="review-footer">
                  <small>ข้อความตอบกลับ</small>
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
              </div>
              <div class="review-card">
                <div class="review-header">
                  <div class="user-info">
                    <div class="user-img">
                      <img src="assets/images/default-profile-img.png" class="img-fluid" />
                    </div>
                    <h5 class="user-number mb-0">0***9</h5>
                  </div>
                  <div class="timestamp">13/8/24</div>
                </div>
                <div class="review-stars">
                  <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i
                    class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i>
                </div>
                <div class="review-body">
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
                <div class="review-footer d-none">
                  <small>ข้อความตอบกลับ</small>
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
              </div>
              <div class="review-card">
                <div class="review-header">
                  <div class="user-info">
                    <div class="user-img">
                      <img src="assets/images/default-profile-img.png" class="img-fluid" />
                    </div>
                    <h5 class="user-number mb-0">0***9</h5>
                  </div>
                  <div class="timestamp">13/8/24</div>
                </div>
                <div class="review-stars">
                  <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i
                    class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i>
                </div>
                <div class="review-body">
                  <p class="mb-0">ยังผลให้มีการกระทำอันป่าเถื่อน ซึ่งเป็นการขัดอย่างร้ายแรงต่อมโนธรรมของมนุษยชาติ
                    และการมาถึงของโลกที่ได้มีการประกาศให้ความมีอิสรภาพในการพูดและความเชื่อ
                    และอิสรภาพจากความหวาดกลัวและความต้องการของมนุษย์</p>
                </div>
                <div class="review-footer d-none">
                  <small>ข้อความตอบกลับ</small>
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
              </div>
              <div class="review-card">
                <div class="review-header">
                  <div class="user-info">
                    <div class="user-img">
                      <img src="assets/images/default-profile-img.png" class="img-fluid" />
                    </div>
                    <h5 class="user-number mb-0">0***9</h5>
                  </div>
                  <div class="timestamp">13/8/24</div>
                </div>
                <div class="review-stars">
                  <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i
                    class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i>
                </div>
                <div class="review-body">
                  <p class="mb-0">
                    ทุกคนย่อมมีสิทธิในความเสมอภาคอย่างเต็มที่ในการได้รับการพิจารณาคดีที่เป็นธรรมและเปิดเผยจากศาลที่อิสระและไม่ลำเอียง
                    ในการพิจารณากำหนดสิทธิและหน้าที่ของตนและข้อกล่าวหาอาญาใดต่อตน</p>
                </div>
                <div class="review-footer">
                  <small>ข้อความตอบกลับ</small>
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
              </div>
              <div class="review-card">
                <div class="review-header">
                  <div class="user-info">
                    <div class="user-img">
                      <img src="assets/images/default-profile-img.png" class="img-fluid" />
                    </div>
                    <h5 class="user-number mb-0">0***9</h5>
                  </div>
                  <div class="timestamp">13/8/24</div>
                </div>
                <div class="review-stars">
                  <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i
                    class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i>
                </div>
                <div class="review-body">
                  <p class="mb-0">
                    ทุกคนย่อมมีสิทธิในความเสมอภาคอย่างเต็มที่ในการได้รับการพิจารณาคดีที่เป็นธรรมและเปิดเผยจากศาลที่อิสระและไม่ลำเอียง
                    ในการพิจารณากำหนดสิทธิและหน้าที่ของตนและข้อกล่าวหาอาญาใดต่อตน</p>
                </div>
                <div class="review-footer d-none">
                  <small>ข้อความตอบกลับ</small>
                  <p class="mb-0">
                    โดยที่ประชาชนแห่งสหประชาชาติได้ยืนยันอีกครั้งไว้ในกฎบัตรถึงศรัทธาในสิทธิมนุษยชนขั้นพื้นฐาน</p>
                </div>
              </div> -->
            </div>
            <div class="d-flex justify-content-center">
              <button class="btn btn-outline-secondary btn-custom"><i
                  class="fa-icon fa-regular fa-plus me-2"></i>โหลดเพิ่มเติม</button>
            </div>
          </div>
        </div>

        <div class="modal fade" id="reviewModal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title"><i class="fa-icon fa-regular fa-pen me-2"></i>เขียนรีวิว</h1>
              </div>
              <div class="modal-body">
                <div class="mb-4">
                  <label class="form-label">ข้อความ</label>
                  <input type="text" class="form-control" placeholder="ความคิดเห็นของคุณ" />
                </div>
                <div class="mb-4">
                  <label class="form-label">คะแนน</label>
                  <div class="form-rating-stars">
                    <span class="star"><i class="fa-icon fa-solid fa-star"></i></span>
                    <span class="star"><i class="fa-icon fa-solid fa-star"></i></span>
                    <span class="star"><i class="fa-icon fa-solid fa-star"></i></span>
                    <span class="star"><i class="fa-icon fa-solid fa-star"></i></span>
                    <span class="star"><i class="fa-icon fa-solid fa-star"></i></span>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">ยกเลิก</button>
                <button type="button" class="btn btn-primary">ส่ง</button>
              </div>
            </div>
          </div>
        </div>
        <div class="push"></div>
      </div>
    </div>
</template>
<script>
import reviewCard from '@/components/sakha/review/reviewCard'
export default {
  components: {
    'app-review-card': reviewCard
  },
  data: () => {
    return { modalShow: false }
  }
}
</script>
<style></style>
